import React from 'react';
import PropTypes from 'prop-types';
import { Switch } from '@paypalcorp/pp-react'; // For some reason if we import it from pp-react-switch, we don't get the inline and secondary label feature

const RenderSwitchComponent = (props) => {
  if (props.reversed) {
    return <SwitchPanel value={props.isChecked ? 'no' : 'yes'} {...props} />;
  }
  return <SwitchPanel value={props.isChecked ? 'yes' : 'no'} {...props} />;
};

RenderSwitchComponent.propTypes = {
  isChecked: PropTypes.bool,
  reversed: PropTypes.bool,
};

// onToggle and isChecked props should be passed down by parent component to use switch value
const SwitchPanel = (props) => {
  const { title, subTitle, isChecked, input, value, id } = props;

  return (
    <>
      <Switch
        inline
        id={id}
        className="switch-panel badge-component"
        label={title}
        secondaryLabel={subTitle}
        checked={isChecked}
        onChange={() => input.onChange(value === 'yes' ? 'no' : 'yes')}
        value={value}
      />
    </>
  );
};

SwitchPanel.propTypes = {
  input: PropTypes.object,
  isChecked: PropTypes.bool,
  subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  title: PropTypes.string,
  value: PropTypes.string,
};

export default RenderSwitchComponent;
